import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { ConfirmSaleRequestShippingSurchargeMutationResponse, ConfirmSaleRequestShippingSurchargePathParams, ConfirmSaleRequestShippingSurcharge404, ConfirmSaleRequestShippingSurcharge500 } from "../types/ConfirmSaleRequestShippingSurcharge";

/**
 * @summary Запрос на подтверждение доплаты
 * @link /api/salerequests/:requestId/shippings/surcharge/:surchargeId/confirm
 */

export function useConfirmSaleRequestShippingSurcharge <TData = ConfirmSaleRequestShippingSurchargeMutationResponse, TError = ConfirmSaleRequestShippingSurcharge404 | ConfirmSaleRequestShippingSurcharge500>(requestId: ConfirmSaleRequestShippingSurchargePathParams["requestId"], surchargeId: ConfirmSaleRequestShippingSurchargePathParams["surchargeId"], options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "post",
        url: `/api/salerequests/${requestId}/shippings/surcharge/${surchargeId}/confirm`,
        
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
